module.exports = ".content {\r\n    background-color: #e8f1f2;\r\n    margin-bottom: 20px;\r\n    color: #13293d;\r\n    padding: 20px;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/group-detail/group-detail.component.css
// module id = ./src/app/components/group-detail/group-detail.component.css
// module chunks = main